import * as React from 'react';
export const bcaSvg = React.forwardRef(function bcaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0060AF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.892 5h.15a7.445 7.445 0 0 0-.15 0Zm.075 0c2.99.031 5.56 1.908 5.549 5.136-.004 2.12-1.404 3.477-2.426 4.468-.298.288-.563.545-.753.781-1.26 1.578-1.966 3.373-2.011 6.23-.035 2.17-.004 4.553.007 5.385h-.668c-.003-.235-.006-.597-.008-1.049a249.574 249.574 0 0 0-.056-4.265c-.071-2.857-.753-4.723-2.012-6.3-.19-.239-.457-.499-.757-.79-1.019-.99-2.414-2.345-2.421-4.46-.01-3.228 2.561-5.105 5.556-5.136Zm-.847 21.995-.503.002c-.03-1.94-1.132-3.608-2.483-4.481-1.103-.713-2.626-1.22-5.235-1.827-2.44-.566-3.096-2.978-2.362-4.79.792-1.946 2.267-2.622 4.026-2.766 2.543-.287 6.567 3.393 6.537 8.612.028.344.024 2.637.021 4.22l-.001 1.03Zm-1.09.002-.527-.002c-.287-1.312-2.09-1.985-3.23-1.753-.66.133-2.039.395-3.129.354-1.784-.062-2.97-1.638-3.105-2.593-.116-.827.004-2.24.666-2.87.25.528 1.059.942 1.832 1.128 2.5.598 4.05 1.062 5.204 1.768 1.301.8 2.297 2.287 2.288 3.968Zm2.778-1.072c-.003-1.581-.007-3.84.02-4.18-.03-5.219 3.992-8.9 6.537-8.613 1.76.145 3.232.82 4.026 2.766.733 1.813.074 4.225-2.363 4.791-2.61.608-4.132 1.113-5.237 1.827-1.35.873-2.375 2.542-2.406 4.481l-.576-.002-.001-1.07Zm3.375-2.896c-1.298.8-2.293 2.287-2.284 3.968l.522-.002c.288-1.312 2.097-1.985 3.232-1.753.658.133 2.044.395 3.133.354 1.781-.062 2.964-1.638 3.101-2.593.117-.827-.003-2.24-.668-2.87-.246.528-1.053.942-1.828 1.128-2.498.598-4.05 1.062-5.208 1.768Z',
      fill: '#fff',
    }),
  );
});
bcaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bca = {
  category: 'brand',
  colorable: false,
  name: 'bca',
  svg: bcaSvg,
};
